document.addEventListener('DOMContentLoaded', () => {
  // ---------- helpers ----------
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const isEl = (n) => n instanceof Element;

  // mouseenter/mouseleave using over/out
  function onMouseEnter(selector, handler) {
    document.addEventListener('mouseover', (e) => {
      const el = isEl(e.target) ? e.target.closest(selector) : null;
      if (!el) return;
      const r = e.relatedTarget;
      if (isEl(r) && el.contains(r)) return;
      handler(el, e);
    });
  }
  function onMouseLeave(selector, handler) {
    document.addEventListener('mouseout', (e) => {
      const el = isEl(e.target) ? e.target.closest(selector) : null;
      if (!el) return;
      const r = e.relatedTarget;
      if (isEl(r) && el.contains(r)) return;
      handler(el, e);
    });
  }

  function containsInPath(str, url) {
    const u = new URL(url);
    return u.pathname.split('/').includes(str);
  }

  let hoverTimer;
  let escapeTimer;

  // ---------- Mobile collection description toggle ----------
  const mobileDescriptionQuery = window.matchMedia('(max-width: 749px)');
  const collectionDescriptions = $$('[data-mobile-collection-description]');

  function updateCollectionDescription(descriptionWrapper) {
    const content = $('[data-mobile-collection-description-content]', descriptionWrapper);
    const toggle = $('[data-mobile-collection-description-toggle]', descriptionWrapper);
    const label = $('[data-mobile-collection-description-label]', descriptionWrapper);
    if (!content || !toggle || !label) return;

    descriptionWrapper.classList.remove('is-collapsible');

    if (!mobileDescriptionQuery.matches) {
      descriptionWrapper.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      label.textContent = 'Show more';
      return;
    }

    const contentStyles = window.getComputedStyle(content);
    const lineHeight = parseFloat(contentStyles.lineHeight) || parseFloat(contentStyles.fontSize) * 1.5;
    const collapsedHeight = lineHeight * 3;
    const isCollapsible = content.scrollHeight > collapsedHeight + 1;

    descriptionWrapper.classList.toggle('is-collapsible', isCollapsible);

    if (!isCollapsible) {
      descriptionWrapper.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      label.textContent = 'Show more';
    }
  }

  collectionDescriptions.forEach((descriptionWrapper) => {
    const toggle = $('[data-mobile-collection-description-toggle]', descriptionWrapper);
    const label = $('[data-mobile-collection-description-label]', descriptionWrapper);
    if (!toggle || !label) return;

    toggle.addEventListener('click', () => {
      const isExpanded = descriptionWrapper.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      label.textContent = isExpanded ? 'Show less' : 'Show more';
    });

    updateCollectionDescription(descriptionWrapper);
  });

  if (collectionDescriptions.length) {
    window.addEventListener('resize', () => {
      collectionDescriptions.forEach(updateCollectionDescription);
    });
  }


  //--- mobile drawer menu ---//
  
  // ---------- Accordion (#accordiancustom) ----------
 // ---------- Accordion (#accordiancustom) ----------
const accordion = document.getElementById('accordiancustom');
if (accordion) {
  accordion.addEventListener('click', (e) => {
    const link = isEl(e.target) ? e.target.closest('a') : null;
    if (!link) return;

    // Let "See all" and external/internal links that are not accordion toggles behave normally
    if (link.classList.contains('ignore')) return;

    const closestLI = link.closest('li');
    const closestUL = link.closest('ul');
    if (!closestLI || !closestUL) return;

    // Find the *direct* submenu for this LI
    let childUL = null;
    for (const child of closestLI.children) {
      if (child.tagName === 'UL') {
        childUL = child;
        break;
      }
    }

    // No submenu? Then this is a normal link (e.g. a leaf item) — let it navigate.
    if (!childUL) return;

    // This is an accordion toggle, stop navigation
    e.preventDefault();

    const isOpen = childUL.classList.contains('open');

    // Close all siblings at this level
    const siblingLIs = Array.from(closestUL.children).filter(
      (el) => el.tagName === 'LI'
    );
    siblingLIs.forEach((li) => {
      li.classList.remove('active');
      for (const child of li.children) {
        if (child.tagName === 'UL') {
          child.classList.remove('open');
        }
      }
    });

    // If it was *not* open, open it; if it was open, we just closed it (toggle)
    if (!isOpen) {
      childUL.classList.add('open');
      closestLI.classList.add('active');
    }
  });
}


  // ---------- Desktop main menu (OPEN ON HOVER/FOCUS, ALLOW CLICK NAV) ----------
  // Hover open
  onMouseEnter('.header-desktop-list > .main-list > .main-list-child', (item) => {
    $$('.header-desktop-list .sub-menu').forEach((m) => m.classList.remove('open'));
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      const sub = $('.sub-menu', item);
      if (sub) sub.classList.add('open');
    }, 500);
  });

  // Keyboard focus opens submenu (a11y)
  document.addEventListener('focusin', (e) => {
    const item = isEl(e.target) ? e.target.closest('.header-desktop-list > .main-list > .main-list-child') : null;
    if (!item) return;
    $$('.header-desktop-list .sub-menu').forEach((m) => m.classList.remove('open'));
    const sub = $('.sub-menu', item);
    if (sub) sub.classList.add('open');
  });

  // IMPORTANT: Removed the old click handler that called preventDefault.
  // Now clicks on child <a> will navigate normally.

  // Mouseleave closes the sub-menu
  onMouseLeave('.header-desktop-list li', (li) => {
    clearTimeout(hoverTimer);
    const sub = $('.sub-menu', li);
    if (sub) sub.classList.remove('open');
  });

  // ESC closes all desktop sub-menus
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      clearTimeout(escapeTimer);
      escapeTimer = setTimeout(() => {
        $$('.header-desktop-list .sub-menu').forEach((m) => m.classList.remove('open'));
      }, 500);
    }
  });

  // ---------- Category / Brand / Chassis lists ----------
  function wireParentList(listSel, subSel, btnSel) {
    document.addEventListener('click', (e) => {
      const li = isEl(e.target) ? e.target.closest(`${listSel} > li`) : null;
      if (!li) return;
      $$(subSel).forEach((m) => (m.style.display = 'none'));
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        const sub = li.querySelector(subSel);
        if (sub) sub.style.display = 'block';
      }, 500);
      // No preventDefault here either — clicking actual links inside will still navigate.
    });

    onMouseEnter(`${listSel} > li`, (li) => {
      const btn = li.querySelector(btnSel);
      if (btn) btn.classList.add('active');
    });

    onMouseLeave(`${listSel} > li`, (li) => {
      const btn = li.querySelector(btnSel);
      if (btn) btn.classList.remove('active');
    });
  }

  wireParentList('.category-list', '.category-sub-menu', '.category-btn');
  wireParentList('.brand-list', '.brand-sub-menu', '.brand-btn');
  wireParentList('.chassis-list', '.chassis-sub-menu', '.chassis-btn');

  // ---------- SKU toggle + copy ----------
  document.addEventListener('click', (e) => {
    const target = isEl(e.target) ? e.target.closest('.mainproductsku') : null;
    if (!target) return;

    e.stopPropagation();
    const priceMatch = document.getElementById('showpricematch');
    if (priceMatch) {
      priceMatch.classList.toggle('open'); // CSS should animate
    }

    const clean = document.getElementById('cleansku');
    if (clean) {
      const text = clean.innerText || '';
      navigator.clipboard.writeText(text).catch((err) => {
        console.warn('Clipboard copy failed:', err);
      });
    }
  }, { passive: true });

  // ---------- Mobile category button ----------
  document.addEventListener('click', (e) => {
    const btn = isEl(e.target) ? e.target.closest('.category-btn') : null;
    if (!btn) return;

    if (window.innerWidth < 768) {
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.height = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';

      setTimeout(() => {
        const parent = btn.parentElement;
        if (!parent) return;
        parent.querySelectorAll('.sub-menu, .child-sub-menu').forEach((el) => {
          el.classList.add('mobile-open');
        });
      }, 500);
    }
  });

  // ---------- Grid/List view toggles ----------
  const gridBtn = document.getElementById('gridview');
  const listBtn = document.getElementById('listview');
  const gridSection = document.getElementById('shopify-section-template--16085543223483__1663984127e7f42339');
  const listSection = document.getElementById('shopify-section-template--16085543223483__62e039df-fbb7-4f1a-aefe-e2141e4051fe');

  function setActive(btn) {
    const wrap = btn ? btn.closest('.view-btns') : null;
    if (!wrap) return;
    wrap.querySelectorAll('button').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');
  }

  if (gridBtn && listBtn && gridSection && listSection) {
    gridBtn.addEventListener('click', (e) => {
      e.preventDefault();
      setActive(gridBtn);
      gridSection.style.display = '';
      listSection.style.display = 'none';
    });

    listBtn.addEventListener('click', (e) => {
      e.preventDefault();
      setActive(listBtn);
      gridSection.style.display = 'none';
      listSection.style.display = '';
    });
  }
});
